import React, {useEffect, useState} from "react";
import {HttpClient} from "../../../service/httpClient/HttpClient";
import "./InternalImageSelector.scss"
import FileManagerSelector from "../../../pages/fileManager2/selector/FileManagerSelector";
import {FileManagerTypes} from "../../../component/fileManager/FileManager";
import {changeContent, EditorItemType, prepareEditorItem} from "../RaikoCustomEditor2";
import thumbnail from "../image/Focus-cuate.svg"
import {
    DialogSize,
    Fancybox,
    RaikoDefaultDialogPage,
    RaikoSectionContainer
} from "@moeindal/base-raiko-panel-components";

export default function InternalImageSelector(
    {
        value = -1,
        priority,
        editorValue,
        setEditorValue,
        uid
    }
) {

    const [imageUrl, setImageUrl] = useState("");
    const [lastUploadedImageId, setLastUploadedImageId] = useState(-1);

    useEffect(() => {
        if (typeof value !== "undefined" && value >= 0 && value !== lastUploadedImageId) {
            new HttpClient(
                {},
                "application/json",
                process.env.REACT_APP_BASE_URL
            )
                .get(
                    `files/${value}/urls/public`
                ).then(response => {

                setImageUrl(response.downloadUrl)
                setLastUploadedImageId(value)

            }).catch(reason => {
                console.log("image not loading by reason ", reason)
            })

        } else if (value === -1) {
            setImageUrl("")
        }
    }, [value])


    const [galleryDialogOpenState, setGalleryDialogOpenState] = useState(false);

    function handleOpenFileManager() {
        setGalleryDialogOpenState(true)
    }

    function handleSelectImage(id, url) {
        setImageUrl(url)
        setLastUploadedImageId(id)

        changeContent(
            editorValue,
            setEditorValue,
            prepareEditorItem(id, EditorItemType.IMAGE,uid),
            priority)
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={_ => {
                    setGalleryDialogOpenState(false)
                }}
                open={galleryDialogOpenState}
                dialogSize={DialogSize.LARGE}
                pageTitle={"تصویر مورد نظر خود را انتخاب نمایید."}
            >
                <FileManagerSelector
                    setOpenDialog={setGalleryDialogOpenState}
                    bucketId={FileManagerTypes.POST_IMAGES.id}
                    setSelectedFileUrl={handleSelectImage}
                />

            </RaikoDefaultDialogPage>
            <div className={"baseInternalImageSelector"}>

                <div className={"internalImageItemsContainer"}>
                    <RaikoSectionContainer
                        title={"تصویر تکی"}
                        actionButtonTitle={imageUrl ? "تغییر تصویر" : "انتخاب تصویر"}
                        hasActionButton
                        actionButtonOnclick={handleOpenFileManager}
                    >
                        {
                            imageUrl ? <div className={"imageViewerContainer"}>

                                    <Fancybox
                                        options={{
                                            Carousel: {
                                                infinite: false,
                                            },
                                        }}
                                    >
                                        <a href={imageUrl} data-fancybox={"gallery"} data-caption={priority}>
                                            <img
                                                src={imageUrl}
                                                alt={priority}/>
                                        </a>

                                    </Fancybox>
                                </div> :
                                <div
                                    className={"imageNotSelectedContainer"}
                                    onClick={handleOpenFileManager}
                                >
                                    <img src={thumbnail} alt=""/>
                                    <span>برای انتخاب تصویر کلیک نمایید.</span>

                                </div>
                        }
                    </RaikoSectionContainer>

                </div>


            </div>
        </>
    )
}